import Vue from 'vue'

export default {
  title: state => {
    return state.title
  },
  showPreloader: state => {
    return state.showPreloader
  },
  menu: state => {
    return state.menu
  },
  sessionMenu: state => {
    return state.sessionMenu
  },
  openedSettings: state => {
    return state.openedSettings
  },
  user: state => {
    return state.user
  },
  userAvatar(state) {
    return state.userAvatar
  },
  userStatus: state => {
    return state.userStatus
  },
  load: state => {
    return state.load
  },
  overlay: state => {
    return state.overlay
  },
  selectedDate: state => {
    return state.selectedDate
  },
  isSuperAdmin: state => {
    if (state.user) {
      return state.user.work_position_id == Vue.config.WORK_POSITIONS.SUPER_ADMIN
    }
    return false
  },
  userPermissions(state) {
    let PERMISSION_KEY = null
    const WORK_POSITIONS = Vue.config.WORK_POSITIONS
    const PERMISSIONS_CONFIG = Vue.config.permissions
    const PERMISSON_PREFIX = `_PERMISSIONS`

    if (state.user && state.user.work_position_id) {
      const USER_WORKPOSITION_ID = state.user.work_position_id
      _.each(WORK_POSITIONS, (item, key) => {
        if (item === USER_WORKPOSITION_ID) {
          PERMISSION_KEY = key
        }
      })
      return PERMISSIONS_CONFIG[`${PERMISSION_KEY}${PERMISSON_PREFIX}`]
    }
    return []
  },
  userWorkPosition(state) {
    if (_.has(state, 'user.work_position_id')) {
      return state.user.work_position_id
    }
    return void 0
  },
  userUnit(state) {
    if (_.has(state, 'user.unit_id')) {
      return parseInt(state.user.unit_id)
    }

    return void 0
  },
  userCompany(state) {
    if (_.has(state, 'user.company_id')) {
      return state.user.company_id
    }

    return void 0
  },
  userSelfPermissions(state) {
    return state.selfPermissions
  },
  timezone(state) {
    return state.timezone
  },
}
